export { default as ProfileUnknownIcon } from "./profileBG";
export { default as ProfileGirlIcon } from "./girl";
export { default as ProfileBoyIcon } from "./boy";
export { default as LogoutIcon } from "./logout";
export { default as ParentsIcon } from "./parents";
export { default as SettingsIcon } from "./settings";
export { default as SoundOnIcon } from "./soundOn";
export { default as SoundOffIcon } from "./soundOff";
